module.exports = __webpack_public_path__ + "media/images/logo_text_en-af323834b544919bac5f082166a43cf5.svg";